<div class="home-page">
  <!-- Hero Section -->
  <header class="hero-section">
    <div class="hero-background" style="background-image: url('https://images.ctfassets.net/f6ou4743hwzs/5oJNVQ5JiaRGOwJ9gi41sn/475c51cbb180eecac19ae4af379ecfc3/Homepage.jpeg');"></div>
    <div class="hero-overlay"></div>
    <div class="hero-content">
      <span class="exhibit-type-badge">Historic 1912 Schoolhouse &bull; St. Tammany Parish</span>
      <h1 class="hero-title">Bayou Lacombe Museum</h1>
      <p class="hero-subtitle">Preserving 300+ years of Northshore history, Choctaw heritage, rural bayou life, and living Louisiana traditions.</p>

      <div class="hero-meta">
        <mat-icon>schedule</mat-icon>
        <span>Open Saturdays: Noon – 4:00 PM</span>
      </div>

      <div class="hero-cta-group">
        <a routerLink="/appointment" class="hero-cta-btn primary">
          <mat-icon>calendar_today</mat-icon>
          <span>Plan Your Visit</span>
        </a>
        <a routerLink="/exhibits" class="hero-cta-btn secondary">
          <mat-icon>museum</mat-icon>
          <span>Explore Exhibits</span>
        </a>
      </div>

      <div class="scroll-indicator">
        <span class="scroll-text">Explore</span>
        <mat-icon>keyboard_arrow_down</mat-icon>
      </div>
    </div>
  </header>

  <!-- 1. Quick Info Utility Bar -->
  <section class="quick-info-bar" aria-label="Visitor Essentials">
    <div class="quick-info-container">
      <div class="quick-info-item">
        <div class="quick-info-icon-wrapper">
          <mat-icon>schedule</mat-icon>
        </div>
        <div class="quick-info-text">
          <span class="quick-label">Hours</span>
          <span class="quick-value">Sat: 12:00 PM – 4:00 PM</span>
          <span class="quick-sub">Thu – Sat by appointment</span>
        </div>
      </div>

      <div class="quick-info-divider"></div>

      <div class="quick-info-item">
        <div class="quick-info-icon-wrapper">
          <mat-icon>payments</mat-icon>
        </div>
        <div class="quick-info-text">
          <span class="quick-label">Admission</span>
          <span class="quick-value">Adults $3 &bull; Seniors $2</span>
          <span class="quick-sub">Children under 6 free</span>
        </div>
      </div>

      <div class="quick-info-divider"></div>

      <div class="quick-info-item">
        <div class="quick-info-icon-wrapper">
          <mat-icon>location_on</mat-icon>
        </div>
        <div class="quick-info-text">
          <span class="quick-label">Location</span>
          <span class="quick-value">61115 S St. Mary St</span>
          <span class="quick-sub">Lacombe, LA &bull; Free Parking</span>
        </div>
      </div>

      <div class="quick-info-actions">
        <a href="https://maps.google.com/?q=Bayou+Lacombe+Museum+61115+S+St+Mary+St+Lacombe+LA+70445" 
           target="_blank" 
           rel="noopener noreferrer" 
           class="quick-action-btn secondary">
          <mat-icon>directions</mat-icon>
          <span>Directions</span>
        </a>
        <a routerLink="/appointment" class="quick-action-btn primary">
          <mat-icon>calendar_month</mat-icon>
          <span>Book Tour</span>
        </a>
      </div>
    </div>
  </section>

  <!-- 2. Museum Story & Mission Teaser -->
  <section class="story-teaser-section" aria-labelledby="story-heading">
    <div class="story-teaser-container">
      <div class="story-image-col">
        <div class="story-image-frame">
          <img src="https://images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg" 
               alt="Historic 1912 wooden schoolhouse of Bayou Lacombe Museum surrounded by live oaks"
               loading="lazy" />
          <div class="story-image-badge">
            <mat-icon>account_balance</mat-icon>
            <div>
              <strong>Est. 1912</strong>
              <span>National Register</span>
            </div>
          </div>
        </div>
      </div>

      <div class="story-text-col">
        <span class="section-kicker">300+ Years of Northshore Heritage</span>
        <h2 id="story-heading" class="section-title">Where Bayou History Lives & Breathes</h2>
        <div class="story-accent-bar"></div>
        <p class="story-lead">
          Housed in St. Tammany Parish’s oldest surviving wooden schoolhouse, the Bayou Lacombe Museum celebrates the enduring crosscurrents of Choctaw Native American culture, early French settlers, Father Adrien Rouquette (<em>Chahta-Ima</em>), and timber industry heritage.
        </p>
        <p class="story-body">
          From ancient shell mounds to living All Saints' Day (<em>La Toussaint</em>) traditions and our native botanical gardens, we preserve the real stories of the people who shaped life along the bayou.
        </p>
        <div class="story-cta-row">
          <a routerLink="/about" class="btn-story-primary">
            <span>Read Our Full Story</span>
            <mat-icon>arrow_forward</mat-icon>
          </a>
          <a routerLink="/contact" class="btn-story-secondary">
            <span>Contact & Inquiries</span>
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- 3. Featured Exhibits Showcase -->
  <section class="featured-exhibits-section" aria-labelledby="exhibits-heading">
    <div class="section-header-centered">
      <span class="section-kicker">Permanent & Special Galleries</span>
      <h2 id="exhibits-heading" class="section-title">On View at the Museum</h2>
      <div class="header-line-centered"></div>
      <p class="section-subtitle">
        Explore curated artifacts, rare photographs, and authentic bayou artifacts across our historic schoolhouse galleries.
      </p>
    </div>

    <div class="exhibits-grid">
      <div class="exhibit-preview-card" *ngFor="let ex of exhibits" [routerLink]="['/exhibits', ex.fields.url]">
        <div class="exhibit-card-media" [style.background-image]="'url(' + (ex.fields.image?.fields?.file?.url || 'https://images.ctfassets.net/f6ou4743hwzs/2666n0sNDqIQgCObYIwgKd/28324dd15c6be2a9b6f8ad3aef4373cf/Exhibits.svg') + ')'">
          <div class="exhibit-card-gradient"></div>
          <span class="exhibit-badge">Exhibit</span>
        </div>
        <div class="exhibit-card-content">
          <h3 [innerHTML]="ex.fields.title | mdToHtml"></h3>
          <p class="exhibit-card-desc">Step inside to uncover artifacts, oral histories, and historic archives.</p>
          <div class="exhibit-card-link">
            <span>Explore Details</span>
            <mat-icon>arrow_forward</mat-icon>
          </div>
        </div>
      </div>
    </div>

    <div class="section-footer-cta">
      <a routerLink="/exhibits" class="view-all-exhibits-btn">
        <span>View All Current Exhibits</span>
        <mat-icon>arrow_forward</mat-icon>
      </a>
    </div>
  </section>

  <!-- 4. Upcoming Events Feed -->
  <section class="events-feed-section" aria-labelledby="events-heading">
    <div class="events-feed-container">
      <div class="events-feed-header">
        <div>
          <span class="section-kicker">What's Happening</span>
          <h2 id="events-heading" class="section-title-white">Upcoming Events & Programs</h2>
          <p class="section-subtitle-light">Join us for lectures, garden workshops, cultural gatherings, and community days.</p>
        </div>
        <a routerLink="/events" class="events-all-link">
          <span>All Events Calendar</span>
          <mat-icon>arrow_forward</mat-icon>
        </a>
      </div>

      <div class="events-cards-grid" *ngIf="upcomingEvents && upcomingEvents.length > 0; else noUpcomingEvents">
        <div class="event-feed-card" *ngFor="let ev of upcomingEvents" [routerLink]="['/events', ev.fields.url]">
          <div class="event-feed-media" [style.background-image]="'url(' + (ev.fields.images?.[0]?.fields?.file?.url || 'https://images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg') + ')'">
            <div class="event-date-chip" *ngIf="ev.fields.dateTime">
              <span class="event-date-month">{{ ev.fields.dateTime | date:'MMM' }}</span>
              <span class="event-date-day">{{ ev.fields.dateTime | date:'d' }}</span>
            </div>
          </div>
          <div class="event-feed-body">
            <div class="event-meta-time">
              <mat-icon>schedule</mat-icon>
              <span>{{ (ev.fields.dateTime | date:'shortTime') || ev.fields.date }}</span>
            </div>
            <h3 [innerHTML]="ev.fields.title | mdToHtml"></h3>
            <div class="event-card-action">
              <span>Event Details</span>
              <mat-icon>arrow_forward</mat-icon>
            </div>
          </div>
        </div>
      </div>

      <ng-template #noUpcomingEvents>
        <div class="no-events-banner">
          <mat-icon>event_available</mat-icon>
          <div class="no-events-text">
            <h3>Special Events in Planning</h3>
            <p>We are coordinating seasonal lectures, plant exchanges, and museum celebrations. Explore our archive of past gatherings or subscribe below to be notified.</p>
          </div>
          <a routerLink="/past-events" class="no-events-btn">
            <span>Browse Past Events</span>
            <mat-icon>history</mat-icon>
          </a>
        </div>
      </ng-template>
    </div>
  </section>

  <!-- 5. Group Tours & Special Appointments CTA Banner -->
  <section class="group-tour-banner-section" aria-label="Group Tours Banner">
    <div class="group-tour-banner-container">
      <div class="group-tour-card">
        <div class="group-tour-content">
          <div class="group-tour-badge">
            <mat-icon>groups</mat-icon>
            <span>Schools &bull; Scouts &bull; Private Groups</span>
          </div>
          <h2>Visiting With a Group or During the Week?</h2>
          <p>
            Private docent-guided tours are available Thursday through Saturday by advance appointment. Perfect for local public school field trips, homeschool collectives, historical societies, and family reunions.
          </p>
          <div class="group-tour-benefits">
            <div class="benefit-item">
              <mat-icon>check_circle</mat-icon>
              <span>Docent-led 1912 classroom lesson</span>
            </div>
            <div class="benefit-item">
              <mat-icon>check_circle</mat-icon>
              <span>Choctaw Medicine Wheel garden tour</span>
            </div>
            <div class="benefit-item">
              <mat-icon>check_circle</mat-icon>
              <span>Custom group scheduling & bus parking</span>
            </div>
          </div>
          <div class="group-tour-actions">
            <a routerLink="/appointment" class="btn-group-tour-primary">
              <mat-icon>calendar_month</mat-icon>
              <span>Schedule a Private Tour</span>
            </a>
            <a href="tel:(985) 664-0256" class="btn-group-tour-secondary">
              <mat-icon>phone</mat-icon>
              <span>Call (985) 664-0256</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- 6. Photo Gallery Mosaic / Social Proof -->
  <section class="gallery-mosaic-section" aria-labelledby="gallery-heading">
    <div class="section-header-centered">
      <span class="section-kicker">Moments at the Museum</span>
      <h2 id="gallery-heading" class="section-title">Life Along Bayou Lacombe</h2>
      <div class="header-line-centered"></div>
      <p class="section-subtitle">
        A glimpse into our exhibits, community celebrations, and historic grounds.
      </p>
    </div>

    <div class="gallery-mosaic-grid" *ngIf="galleryImages && galleryImages.length > 0; else fallbackGallery">
      <div class="mosaic-item" *ngFor="let item of galleryImages.slice(0, 6); let i = index" [class.mosaic-tall]="i === 0 || i === 3">
        <img [src]="item.fields.image?.fields?.file?.url || item.fields.file?.url" 
             [alt]="item.fields.title || 'Bayou Lacombe Museum photo'" 
             loading="lazy" />
        <div class="mosaic-overlay">
          <span class="mosaic-title" *ngIf="item.fields.title">{{ item.fields.title }}</span>
          <mat-icon>zoom_in</mat-icon>
        </div>
      </div>
    </div>

    <ng-template #fallbackGallery>
      <div class="gallery-mosaic-grid">
        <div class="mosaic-item mosaic-tall">
          <img src="https://images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg" alt="Bayou Lacombe Museum Schoolhouse" loading="lazy" />
          <div class="mosaic-overlay">
            <span class="mosaic-title">1912 Historic Wooden Schoolhouse</span>
          </div>
        </div>
        <div class="mosaic-item">
          <img src="https://images.ctfassets.net/f6ou4743hwzs/5oJNVQ5JiaRGOwJ9gi41sn/475c51cbb180eecac19ae4af379ecfc3/Homepage.jpeg" alt="Bayou Lacombe Waterfront" loading="lazy" />
          <div class="mosaic-overlay">
            <span class="mosaic-title">Bayou Lacombe Waters</span>
          </div>
        </div>
        <div class="mosaic-item">
          <img src="https://images.ctfassets.net/f6ou4743hwzs/2666n0sNDqIQgCObYIwgKd/28324dd15c6be2a9b6f8ad3aef4373cf/Exhibits.svg" alt="Museum Exhibit Display" loading="lazy" />
          <div class="mosaic-overlay">
            <span class="mosaic-title">Exhibits & Archives</span>
          </div>
        </div>
        <div class="mosaic-item mosaic-tall">
          <img src="https://images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg" alt="Botanical Gardens" loading="lazy" />
          <div class="mosaic-overlay">
            <span class="mosaic-title">Native Heritage Gardens</span>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="section-footer-cta">
      <a routerLink="/gallery" class="view-gallery-btn">
        <mat-icon>photo_library</mat-icon>
        <span>View Complete Photo Gallery</span>
      </a>
    </div>
  </section>

  <!-- 7. Support & Get Involved Split Panel -->
  <section class="support-split-section" aria-label="Support and Get Involved">
    <div class="split-panel-grid">
      <!-- Donate Panel -->
      <div class="split-panel-card donate-panel">
        <div class="split-panel-content">
          <div class="panel-icon-circle">
            <mat-icon>volunteer_activism</mat-icon>
          </div>
          <span class="panel-tag">501(c)(3) Tax-Deductible</span>
          <h2>Preserve Our Heritage</h2>
          <p>
            Your gift directly funds acid-free archival storage, historic schoolhouse climate control, and free educational museum admissions for local school children.
          </p>
          <div class="panel-perk-list">
            <div><mat-icon>check</mat-icon> 100% of contributions stay in Lacombe</div>
            <div><mat-icon>check</mat-icon> Immediate tax receipt for your records</div>
          </div>
          <a routerLink="/donate" class="btn-panel-action btn-donate">
            <span>Make a Tax-Deductible Donation</span>
            <mat-icon>arrow_forward</mat-icon>
          </a>
        </div>
      </div>

      <!-- Membership Panel -->
      <div class="split-panel-card member-panel">
        <div class="split-panel-content">
          <div class="panel-icon-circle">
            <mat-icon>card_membership</mat-icon>
          </div>
          <span class="panel-tag">Annual Support</span>
          <h2>Join the Museum Family</h2>
          <p>
            Become an active guardian of Louisiana history. Enjoy unlimited annual admission, private exhibit preview receptions, our official museum ceramic mug, and store discounts.
          </p>
          <div class="panel-perk-list">
            <div><mat-icon>check</mat-icon> Starting at just $20/year for Seniors & Students</div>
            <div><mat-icon>check</mat-icon> Family plans include household free admission</div>
          </div>
          <a routerLink="/memberships" class="btn-panel-action btn-member">
            <span>Explore Membership Tiers</span>
            <mat-icon>arrow_forward</mat-icon>
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- 8. Newsletter Signup & Community Stay Connected -->
  <section class="newsletter-section" aria-labelledby="newsletter-heading">
    <div class="newsletter-card">
      <div class="newsletter-icon-badge">
        <mat-icon>mark_email_read</mat-icon>
      </div>
      <span class="section-kicker">Stay Connected</span>
      <h2 id="newsletter-heading" class="newsletter-title">Northshore History in Your Inbox</h2>
      <p class="newsletter-sub">
        Receive our monthly newsletter with upcoming events, historical stories, botanical bloom updates, and community lectures. Never any spam.
      </p>

      <div class="newsletter-form-container" *ngIf="!newsletterSuccess; else newsletterThankYou">
        <form (ngSubmit)="onNewsletterSubmit()" class="newsletter-form">
          <div class="newsletter-input-wrapper">
            <mat-icon class="input-mail-icon">email</mat-icon>
            <input type="email" 
                   name="newsletterEmail" 
                   [(ngModel)]="newsletterEmail" 
                   placeholder="Enter your email address" 
                   autocomplete="email"
                   required />
          </div>
          <button type="submit" class="newsletter-submit-btn" [disabled]="newsletterLoading">
            <mat-icon *ngIf="!newsletterLoading">send</mat-icon>
            <span>{{ newsletterLoading ? 'Subscribing...' : 'Subscribe' }}</span>
          </button>
        </form>
        <p class="newsletter-error" *ngIf="newsletterError">{{ newsletterError }}</p>
        <span class="privacy-note">We respect your privacy. You can unsubscribe at any time with one click.</span>
      </div>

      <ng-template #newsletterThankYou>
        <div class="newsletter-success-box">
          <mat-icon>check_circle</mat-icon>
          <h3>You're Subscribed!</h3>
          <p>Thank you for joining our community! Look out for our welcome email and upcoming event announcements.</p>
        </div>
      </ng-template>
    </div>
  </section>
</div>